import {Entity} from '../core/entity/core.base.entity';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {AppEntity} from './app.entity';
import {SystemEntity} from './system.entity';

@EntityTable('app_system_xref', 'e3556f3d-0ec5-41d7-8b99-9ce22fbf4f5e')
export class AppSystemXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, false, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @JoinColumn(FieldTypeKind.GUID, AppEntity, false, false, FieldRelationKind.BELONGS_TO, 'app')
    public appId: string;

}
